import DOMPurify from "dompurify";

// Covers marked (GFM) output plus what markdown.tsx adds: sized images, OpenCloud chip with its icon, links.
const ALLOWED_TAGS = [
  "a",
  "abbr",
  "b",
  "blockquote",
  "br",
  "code",
  "del",
  "details",
  "div",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "input",
  "kbd",
  "li",
  "mark",
  "ol",
  "p",
  "path",
  "pre",
  "s",
  "span",
  "strong",
  "sub",
  "summary",
  "sup",
  "svg",
  "table",
  "tbody",
  "td",
  "th",
  "thead",
  "tr",
  "u",
  "ul",
];

const ALLOWED_ATTR = [
  "align",
  "alt",
  "aria-hidden",
  "checked",
  "class",
  "colspan",
  "d",
  "disabled",
  "fill",
  "height",
  "href",
  "open",
  "rel",
  "rowspan",
  "src",
  "start",
  "stroke",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-width",
  "target",
  "title",
  "type",
  "viewBox",
  "width",
  "xmlns",
];

// http, https, mailto, or anything without a scheme (relative paths, #anchors).
const ALLOWED_URI_REGEXP = /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i;

let hooked = false;

function installHooks(): void {
  if (hooked) return;
  hooked = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      if (node.getAttribute("target") === "_blank") node.setAttribute("rel", "noopener noreferrer");
      else node.removeAttribute("target");
    }
    if (node.tagName === "INPUT") {
      if (node.getAttribute("type") !== "checkbox") node.remove();
      else node.setAttribute("disabled", "");
    }
  });
}

export function sanitizeHtml(html: string): string {
  installHooks();
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
  });
}
